import { Box, FormControl } from "@primer/react";
import { useEffect, useState } from "react";
import ComboboxTinhTrangHonNhan from "../../../components/combobox-tinh-trang-hon-nhan";
import MyButton from "../../../components/ui/button";
import TextInput from "../../../components/ui/text-input";
import FormBlock from "../profile-form/FormBlock";
import { TinhTrangHonNhan } from "../../../models/request/hoc-sinh/TinhTrangHonNhan";
import { crmHocSinhApi } from "../../../api/crmHocSinhApi";
import { NotifyHelper } from "../../../helpers/toast";
interface Props {
    ts_hocsinh_id: number;
}
const TinhTrangHonNhanPHPage: React.FC<Props> = (props: Props) => {
    const [tinhTrangHonNhan, setTinhTrangHonNhan] = useState<TinhTrangHonNhan>({
        hoc_sinh_id: props.ts_hocsinh_id
    });

    const saveTinhTrangHonnhan = async () => {
        var res = await crmHocSinhApi.UpdatePhuHuynhTinhTrangHonNhan(tinhTrangHonNhan);
        if (res.is_success) {
            NotifyHelper.Success("Success");
        } else {
            NotifyHelper.Error(res.message ?? "");
        }
    }

    useEffect(() => {
        const fetchTinhTrangHonNhan = async () => {
            try {
                const res = await crmHocSinhApi.SelectTinhTrangHonNhanPH(props.ts_hocsinh_id);
                setTinhTrangHonNhan(prev => ({
                    hoc_sinh_id: props.ts_hocsinh_id,
                    dm_tinhtrang_honnhan_id: res.data?.dm_tinhtrang_honnhan_id,
                    ghi_chu_tt_hn_ph: res.data?.ghi_chu_tt_hn_ph ?? "",
                }));
            } catch (error) {
            }
        };

        if (props.ts_hocsinh_id) {
            fetchTinhTrangHonNhan();
        }
    }, [props.ts_hocsinh_id]);
    return (
        <Box>
            <FormBlock caption="">
                <Box sx={{
                    display: "grid",
                    gap: 2
                }}>
                    <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr 1fr" }}>
                        <FormControl.Label sx={{ fontWeight: 600, fontSize: 24 }}>Tình trạng hôn nhân phụ huynh</FormControl.Label>
                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <MyButton text="Lưu thay đổi"
                                size="medium"
                                variant="primary"
                                onClick={() => {
                                    saveTinhTrangHonnhan();
                                }}
                            />
                        </Box>

                    </Box>
                    <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr 3fr" }}>
                        <FormControl>
                            <FormControl.Label>Tình trạng hôn nhân</FormControl.Label>
                            <ComboboxTinhTrangHonNhan
                                value={tinhTrangHonNhan?.dm_tinhtrang_honnhan_id}
                                onValueChanged={(value) => {
                                    setTinhTrangHonNhan(prev => ({
                                        hoc_sinh_id: props.ts_hocsinh_id,
                                        dm_tinhtrang_honnhan_id: value,
                                        ghi_chu_tt_hn_ph: prev?.ghi_chu_tt_hn_ph ?? "",
                                    }))
                                }}
                            />
                        </FormControl>
                        <FormControl>
                            <FormControl.Label>Ghi chú</FormControl.Label>
                            <TextInput
                                block
                                name="ghi_chu"
                                required={false}
                                value={tinhTrangHonNhan?.ghi_chu_tt_hn_ph ?? ""}
                                onChange={(event) => {
                                    setTinhTrangHonNhan(prev => ({
                                        hoc_sinh_id: props.ts_hocsinh_id,
                                        dm_tinhtrang_honnhan_id: prev?.dm_tinhtrang_honnhan_id,
                                        ghi_chu_tt_hn_ph: event.target.value,
                                    }))
                                }}
                            />
                        </FormControl>
                    </Box>
                </Box>
            </FormBlock>
        </Box>
    );
};

export default TinhTrangHonNhanPHPage;